<div class="sidebar-wrapper tire-storage-sidedrawer" id="tire-storage-sidebar">
    <p-sidebar
    styleClass="p-sidebar-md"
    dismissible="false"
    blockScroll="false"
    position="right"
    cache="false"
    [showCloseIcon]="false"
    [dismissible]="false"
    [(visible)]="isSidebarVisible"
    (onHide)="handleResetData()">
        <div class="sidebar-container" #sidebarContainer>
            <!-- header container -->
            <div class="ts-header flex-between-center border-bottom-lightest">
                <span class="title-customer">{{customerSearchKey}}</span>
                <span class="pointer" (click)="dismissSidePanel()">
                    <i class="fa fa-times font-18 font-400 font-gray-55"></i>
                </span>
            </div>
            <!-- container body -->
            <div class="sidebar-container-body">
                <p-accordion styleClass="tire-storage-sidepanel-acc" expandIcon="pi pi-fw pi-chevron-down"
                collapseIcon="pi pi-fw pi-chevron-up">
                    <p-accordionTab (click)="handleRadioChange(itemIndex)" [selected]="selectedIndex === itemIndex" class="ts-body border-bottom-light" *ngFor="let item of tireStorages; let itemIndex = index">
                        <p-header>
                            <app-radio-button id="ts-1" name="apt-status" [label]="'TS#'+ item?.externalId" labelColor="font-black"
                                styleClassLabel="font-18 font-600" [selectedValue]="selectedIndex"
                                [value]="itemIndex">
                            </app-radio-button>
                        </p-header>
                        <div class="flex-column gap-16px pb-10">
                            <div class="gap-16px flex-start-start">
                                <div class="flex-between-center ui-g-6 ts-info gap-2">
                                    <span class="font-400 font-14">Seasonality</span>
                                    <span class="font-black font-14 font-600 capitalize">{{item?.seasonality || ''}}</span>
                                </div>
                                <!-- <div class="flex-between-center ui-g-4 ts-info">
                                    <span class="font-400 font-14">Wheel Type</span>
                                    <span class="font-black font-14 font-600 capitalize">{{item?.rimType || ''}}</span>
                                </div> -->
                                <div class="flex-between-center ui-g-6 ts-info gap-2" tooltipPosition="top" [pTooltip]="item?.location">
                                    <span class="font-400 font-14">Location</span>
                                    <span class="font-black font-14 font-600 capitalize text-truncate">{{item?.location || ''}}</span>
                                </div>
                            </div>
    
                            <div class="tire-info" *ngFor="let tireInfo of item?.tiresInfo">
                                <!-- header -->
                                <div class="tire-info-header flex-between-start border-bottom-lightest">
                                    <div class="tire-position flex-start-center flex-wrap gap-12px">
                                        <span class="font-16 font-600 font-black">{{tireInfo?.tireLabel || tirePositionOptionsMapping[tireInfo?.tirePosition] || ''}}</span>
                                        <ng-container  *ngIf="!tireInfo?.isLoading && tireInfo?.conditions && tireInfo?.conditions?.length">
                                            <span class="tire-tread" *ngFor="let condition of tireInfo?.conditions">
                                                {{condition?.name || ''}}
                                            </span>
                                        </ng-container>
                                        <span class="tire-tread" *ngIf="tireInfo.treadDepth">
                                            {{ getTireInfoTread(tireInfo) }} / 32
                                        </span>
                                    </div>
    
                                    <div class="tire-status" [ngClass]="{'pass': tireInfo?.isPassed, 'fail': !tireInfo?.isPassed && !tireInfo?.isLoading, 'loading': tireInfo?.isLoading}" *ngIf="item?.orderInspectionId">
                                        <span *ngIf="!tireInfo?.isLoading">{{tireInfo?.isPassed ? 'Passed' : 'Failed'}}</span>
                                        <i class="fa fa-spinner rotate" *ngIf="tireInfo?.isLoading"></i>
                                    </div>
                                    <div class="tire-status" [ngClass]="{'pass': tireInfo?.isPassed, 'fail': !tireInfo?.isPassed && !tireInfo?.isLoading}" *ngIf="!item?.orderInspectionId && tireInfo.treadDepth">
                                        <span>{{tireInfo?.isPassed ? 'Passed' : 'Failed'}}</span>
                                    </div>
                                    <div class="tire-status not-inspected" *ngIf="!item?.orderInspectionId && !tireInfo.treadDepth">
                                        <span>Not Inspected</span>
                                    </div>
                                </div>
                                <!-- body -->
                                <div class="tire-info-body-wrapper flex-column flex-start-start">
                                    <div class="gap-12px flex-row w-100">
                                        <div class="flex-column ui-g-4 p-0">
                                            <span class="info-text-color font-14 font-400">Brand &amp; Name</span>
                                            <span class="info-text-color font-16 font-600">{{tireInfo?.brand?.name || ''}}</span>
                                        </div>
                                        <div class="flex-column ui-g-4 p-0">
                                            <span class="info-text-color font-14 font-400">Size</span>
                                            <span class="info-text-color font-16 font-600">{{tireInfo?.size || ''}}</span>
                                        </div>
                                        <div class="flex-column ui-g-4 p-0">
                                            <span class="info-text-color font-14 font-400">Wheel Type</span>
                                            <span class="info-text-color font-16 font-600">{{tireInfo?.rimType || ''}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <!-- fail case -->
                            <!-- <div class="tire-info">
                                <div class="tire-info-header flex-between-center border-bottom-lightest">
                                    <div class="tire-position flex-start-center gap-12px">
                                        <span class="font-16 font-600 font-black">Front Left</span>
                                        <span class="tire-tread">5/32”</span>
                                    </div>
    
                                    <div class="tire-status fail">
                                        Failed
                                    </div>
                                </div>
                                <div class="tire-info-body-wrapper flex-column flex-start-start">
                                    <div class="gap-12px flex-row w-100">
                                        <div class="flex-column ui-g-6 p-0">
                                            <span class="info-text-color font-14 font-400">Brand &amp; Name</span>
                                            <span class="info-text-color font-16 font-600">Yokohama Advan DB</span>
                                        </div>
                                        <div class="flex-column ui-g-6 p-0">
                                            <span class="info-text-color font-14 font-400">Size</span>
                                            <span class="info-text-color font-16 font-600">225/45/R18</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </p-accordionTab>
                    
                </p-accordion>
            </div>
            
            <!-- footer -->
            <div class="sidebar-container-footer flex-row">
                <button class="btn btn-qoute-tire ui-g-6" (click)="openQTQModal()" *ngIf="!estimateURL">
                    Quote a tire replacement
                </button>
                <button class="btn btn-replace-tire ui-g-6 text-truncate" tooltipPosition="top"
                    pTooltip="Click to visit the repair order" (click)="openEstimate(estimateURL, estimateData?._id)" *ngIf="estimateURL">
                    Replacement tires added to RO# {{estimateData?.code || ''}}
                </button>
                <button class="btn ui-g-6" [ngClass]="isTireScheduleForReturn ? 'btn-replace-tire' : 'btn-primary'" [disabled]="isProcessing || isTireScheduleForReturn" (click)="handleScheduleReturn()">
                    {{isTireScheduleForReturn ? 'Tires scheduled for return' : 'Schedule Return'}}
                    <i class="fa fa-spinner rotate" *ngIf="isProcessing"></i>
                </button>
            </div>
        </div>
        
    </p-sidebar>
</div>